'use clients';

// Trevor is very knowledgeable of amazon systems and has good domain knowledge of the systems he is working on.

// Well execution, deliver results, dive deep are the super-powers for Trevor

import type { Testimonial } from '../../types/about-page';

const currentYear = new Date().getFullYear();
const RELATIONSHIPS = {
  Amazon: 'Amazonian',
};

const MANAGER_TESTIMONY: Testimonial = {
  year: currentYear,
  testimonial:
    "Trevor is a highly skilled and proactive frontend developer known for his ability to deliver projects efficiently and improve developer experience. He demonstrates a strong bias for action by implementing new solutions for infrastructure and consistently seeks opportunities to enhance systems. Trevor's expertise in TypeScript and frontend frameworks, coupled with his knack for problem-solving, enables him to devise elegant solutions to complex problems. His curiosity and eagerness to learn new UI technologies contribute to his ability to adapt quickly and lead UI projects effectively. Trevor's commitment to continuous improvement is evident through his iterative approach to refining his work and challenging ideas to ensure long-term success. Overall, Trevor's dedication, expertise, and proactive approach make him a valuable asset to the team.",
  relation: RELATIONSHIPS.Amazon,
  isActive: true,
  Component: (
    <span>
      Trevor is a highly skilled and proactive frontend developer known for his
      ability to deliver projects efficiently and improve developer experience.
      He demonstrates a strong bias for action by implementing new solutions for
      infrastructure and consistently seeks opportunities to enhance systems.
      Trevor's expertise in TypeScript and frontend frameworks, coupled with his
      knack for problem-solving, enables him to devise elegant solutions to
      complex problems. His curiosity and eagerness to learn new UI technologies
      contribute to his ability to adapt quickly and lead UI projects
      effectively. Trevor's commitment to continuous improvement is evident
      through his iterative approach to refining his work and challenging ideas
      to ensure long-term success. Overall, Trevor's dedication, expertise, and
      proactive approach make him a valuable asset to the team.
    </span>
  ),
  categories: ['Frontend', 'Deliverables', 'Continuous Improvement'],
};

const NEW_TESTIMONIES: Testimonial[] = [
  {
    year: currentYear,
    testimonial:
      'Trever has good technical knowledge and focus on innovative ideas',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trever has good technical knowledge and focus on innovative ideas
      </span>
    ),
    categories: ['Technical Knowledge', 'Innovation'],
  },
  {
    year: currentYear,
    testimonial:
      'Trevor demonstrates admirable curiosity that enables him to quickly grasp new UI technologies and frameworks. This learning agility is visible in the UI projects he leads, like the RADAR frontend and Service Health Tracker, where incorporated modern advances to enhance the user experience. Trevor consistently spots and seizes opportunities to fine-tune web interfaces for optimal speed and responsiveness.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor demonstrates admirable curiosity that enables him to quickly
        grasp new UI technologies and frameworks. This learning agility is
        visible in the UI projects he leads, like the RADAR frontend and Service
        Health Tracker, where incorporated modern advances to enhance the user
        experience. Trevor consistently spots and seizes opportunities to
        fine-tune web interfaces for optimal speed and responsiveness.
      </span>
    ),
    categories: ['Curiosity', 'UI/UX'],
  },
  {
    year: currentYear,
    testimonial:
      'Trevor is a talented developer, and his code is clean and efficient for the most part. His grasp of typescript and front end frameworks is great. He does have a knack for breaking down intricate problems into manageable pieces and devising elegant solutions. One such example would be devising pivoting solutions around huge amount of data we have in Service Health Tracker in every possible format with high efficiency and low latency.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is a talented developer, and his code is clean and efficient for
        the most part. His grasp of typescript and front end frameworks is
        great. He does have a knack for breaking down intricate problems into
        manageable pieces and devising elegant solutions. One such example would
        be devising pivoting solutions around huge amount of data we have in
        Service Health Tracker in every possible format with high efficiency and
        low latency.
      </span>
    ),
    categories: ['Development', 'Deliverables'],
  },
  {
    year: currentYear,
    testimonial:
      'Trevor is constantly iterating on his existing work, and growing in his level of understanding as a result.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is constantly iterating on his existing work, and growing in his
        level of understanding as a result.
      </span>
    ),
    categories: ['Iteration', 'Growth'],
  },
  {
    year: currentYear,
    testimonial:
      'Trevor is great at developing systems and has delivered numerous projects in the frontend such as Service Health Tracker and RADAR. Trevor has a great bias for action by implementing new solutions for infrastructure and always looking for things to improve the developer experience. Trevor is very knowledgeable of best practices and software design.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is great at developing systems and has delivered numerous
        projects in the frontend such as Service Health Tracker and RADAR.
        Trevor has a great bias for action by implementing new solutions for
        infrastructure and always looking for things to improve the developer
        experience. Trevor is very knowledgeable of best practices and software
        design.
      </span>
    ),
    categories: ['Systems Development', 'Best Practices'],
  },
  {
    year: currentYear,
    testimonial:
      'Trevor is quick to take ownership of whatever task is handed to him. He gets things done, challenging ideas when necessary to ensure long-term results.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is quick to take ownership of whatever task is handed to him. He
        gets things done, challenging ideas when necessary to ensure long-term
        results.
      </span>
    ),
    categories: ['Ownership', 'Deliverables'],
  },
  {
    year: currentYear,
    testimonial:
      'Trevor is very knowledgeable about FE development. I worked with him on UI revamp project of SHT. Trevor has a tendency to always think "what more can we do for the customer" which is very good for the team as it brings in new suggestions and perspectives.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is very knowledgeable about FE development. I worked with him on
        UI revamp project of SHT. Trevor has a tendency to always think "what
        more can we do for the customer" which is very good for the team as it
        brings in new suggestions and perspectives.
      </span>
    ),
    categories: ['Frontend', 'Customer Focus'],
  },
];

export const TESTIMONIAL_LIST: Testimonial[] = [
  {
    year: currentYear - 3,
    testimonial:
      'Trevor is go to person for frontend development and has done great with developing UIs. He is always well-informed with latest technologies and looks for improvements where ever possible.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {'Trevor is the '}
        <i>{"team's"} go-to person for frontend development</i> and has done
        great with developing UIs. He is always well-informed with latest
        technologies and looks for improvements where ever possible.
      </span>
    ),
    categories: ['Frontend', 'UI/UX'],
  },
  {
    year: currentYear - 2,
    testimonial:
      'Trevor is very inquisitive and always looks for opportunities for doing things better. He strives for delivering results quickly while maintaining highest standards. For ex, working on monitoring tool, he quickly identified the data was too heavy for the UI and quickly made memoization provisions that helped in rendering the data faster with a much improved UI experience providing more value to our end customer.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is very inquisitive and always looks for opportunities for doing
        things better. He{' '}
        <i>
          strives for delivering results quickly while maintaining highest
          standards
        </i>
        {'. For ex, working on '}
        <b>Project D</b>, he quickly identified the data was too heavy for the
        UI and quickly made memoization provisions that helped in rendering the
        data faster with a much improved UI experience providing more value to
        our end customer.
      </span>
    ),
    categories: ['DevOps', 'UI/UX'],
  },
  {
    year: currentYear - 1,
    testimonial:
      "Trevor's super power is that he is a perfectionist. I have seen him working primarily with front-end applications and he is always striving to achieve results that will be the most beneficial to the customers we are serving. He is always asking the right questions to ensure we have the best vision for the product that we are building.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor's super power is that he is a perfectionist. I have seen him
        working primarily with front-end applications and he is always striving
        to achieve results that will be the most beneficial to the customers we
        are serving. He is
        <i>
          {' '}
          always asking the right questions to ensure we have the best vision
          for the product that we are building.
        </i>
      </span>
    ),
    categories: ['Frontend', 'Hosting'],
  },
  {
    year: 2020,
    testimonial:
      "During development of Scorecard I constantly observed Trevor's passion for delivering better user experience and his passion to explore and deliver more than asked for, Scorecard detail views are examples for the same, awesome qualities for a relatively new Engineer. He quickly gets into action for any task given to him, Scorecard features are examples for the same.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {'During development of '}
        <b>Project A</b>
        {
          ", I constantly observed Trevor's passion for delivering better user experiences and his passion to explore and deliver more than asked for. "
        }
        <b>Project A</b>
        {"'s"}
        {
          ' detail views are examples for the same, awesome qualities for a relatively new Engineer. He quickly gets into action for any task given to him, all of '
        }
        <b>Project A</b>'s
        {' features are examples of this.'}
      </span>
    ),
    categories: ['Deliverables', 'UI/UX'],
  },
  {
    year: currentYear - 3,
    testimonial:
      "Trevor has an excellent attention to detail when it comes to the UX. He understands the customer requirements without missing a single detail and tries to come up with at least a couple of ideas for the requirement. The UX for the AFT EE customers has significantly improved in the last one year, thanks to Trevor's innovative skills.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor has an{' '}
        <i>excellent attention to detail when it comes to the UX</i>. He
        understands the customer requirements without missing a single detail
        and tries to come up with at least a couple of ideas for the
        requirement. The UX for <b>Project C</b>
        {
          " customers has significantly improved in the last one year, thanks to Trevor's innovative skills."
        }
      </span>
    ),
    categories: ['Deliverables', 'UI/UX'],
  },
  {
    year: currentYear - 2,
    testimonial:
      "Trevor has consistently demonstrated to be very reliable on the front-end development of our Team's software applications. Even with no guidance, he has always took the time to research and study best practices and the industry standard for developing web applications - this is evident in his contributions on the revamp of our services like Scorecard and Availability Dashboard (TT/MCM).",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor has consistently demonstrated to be{' '}
        <i>very reliable on the front-end development</i> of our {" Team's "}{' '}
        software applications. Even with no guidance, he has always took the
        time to research and study best practices and the industry standard for
        developing web applications - this is evident in his contributions on
        the revamp of our services like <b>Project A</b>
        {' and '}
        <b>Project C</b>.
      </span>
    ),
    categories: ['Frontend'],
  },
  {
    year: currentYear - 2,
    testimonial:
      "Trevor's super power is working hard and building systems at an incredible pace while maintaining focus on the customer. He is up to date with best practices and news in tech. Trevor is also very good at mentoring and provides tips and tricks that has helped me increase my productivity.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor's super power is working hard and building systems at an
        incredible pace while maintaining focus on the customer. He is up to
        date with best practices and news in tech. Trevor is also{' '}
        <i>
          very good at mentoring and provides tips and tricks that help increase
          the team's productivity
        </i>
        .
      </span>
    ),
    categories: ['Deliverables', 'Mentoring'],
  },
  {
    year: currentYear - 1,
    testimonial:
      'Trevor seems to be an expert in his domain. I worked with trevor in scoping and analysing a project and he assisted and clarified my doubts really well. he seems very approachable and reliable',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {'Trevor seems to be an '}
        <i>expert in his domain</i>.
        {
          ' I worked with Trevor in scoping and analysing a project and he assisted and clarified my doubts really well. He seems very approachable and reliable'
        }
      </span>
    ),
    categories: ['Mentoring'],
  },
  {
    year: currentYear - 1,
    testimonial:
      "Trevor was one of the engineers in the team who was able to understand the Amazon ecosystem and the team's code repos in a very short span. In less than a quarter, he started picking up some actual production impact tasks and was able to deliver them efficiently. He also comes up with his own ideas which is much appreciated.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {'Trevor was one of the engineers in the team who '}
        <i>
          was able to understand the Amazon ecosystem and the {" team's "} code
          repos in a very short span.
        </i>
        {
          ' In less than a quarter, he started picking up some actual production impact tasks and was able to deliver them efficiently. He also comes up with his own ideas which is much appreciated.'
        }
      </span>
    ),
    categories: ['Architecture', 'Deliverables'],
  },
  {
    year: currentYear - 2,
    testimonial:
      'Trevor always takes on many front end tasks and delivers features on a timely basis. The solutions that he creates are both nice looking and easy to use.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {
          'Trevor always takes on many front end tasks and delivers features on a timely basis. '
        }
        <i>
          The solutions that he creates are both nice looking and easy to use.
        </i>
      </span>
    ),
    categories: ['Frontend'],
  },
  {
    year: currentYear - 2,
    testimonial:
      "Trevor's super powers are his ability to own, bias for action and deep dive that helped the team during CAAM efforts. Listen attentively, speak candidly, treats others respectfully and is available for help anytime helped him earn the teams trust.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {
          "Trevor's super powers are his ability to own, bias for action and deep dive that helped the team during "
        }
        <b>Project B</b>
        {
          ' efforts. Listen attentively, speak candidly, treats others respectfully and is available for help anytime helped him earn the teams trust.'
        }
      </span>
    ),
    categories: ['Deliverables'],
  },
  {
    testimonial:
      'Trevor has an exceptional willingness to grow and find knowledge. He is consistently able to find the solutions to hard problems, and always willing to iterate on his ideas, implementations, and even his own knowledge.',
    relation: RELATIONSHIPS.Amazon,
    year: currentYear - 1,
    isActive: true,
    Component: (
      <span>
        Trevor has an exceptional willingness to grow and find knowledge. He is
        consistently able to find the solutions to hard problems, and{' '}
        <i>
          always willing to iterate on his ideas, implementations, and even his
          own knowledge
        </i>
        .
      </span>
    ),
    categories: ['Mentoring'],
  },
  {
    testimonial:
      'Trevor is fantastic at taking an assigned task, then making progress on getting it done quickly. They regularly deliver features and changes to the website UX as customers express their needs, even in challenging cases where the feedback is in response to a bug or a complaint about features during peak prep.',
    relation: RELATIONSHIPS.Amazon,
    year: currentYear - 1,
    isActive: true,
    Component: (
      <span>
        Trevor is fantastic at taking an assigned task, then making progress on
        getting it done quickly. He{' '}
        <i>
          {' '}
          regularly deliver features and changes to the website UX as customers
          express their needs, even in challenging cases{' '}
        </i>
        where the feedback is in response to a bug or a complaint about features
        during peak prep.
      </span>
    ),
    categories: ['UI/UX', 'Deliverables'],
  },
  {
    testimonial:
      'Trevor is quick in understanding customer requirements and is very flexible in his action plan which is a result of his deep knowledge of our systems. For example, in  the constant changing requirements and features when building the Project C frontend, he made sure he delivered on time. Additionally, he always has a holistic approach for the problem at hand and is direct in his feedback.',
    relation: RELATIONSHIPS.Amazon,
    year: currentYear - 1,
    isActive: true,
    Component: (
      <span>
        Trevor is quick in understanding customer requirements and is very
        flexible in his action plan which is a result of his deep knowledge of
        our systems. For example, in the constant changing requirements and
        features when building the <b>Project C</b> frontend, he made sure he
        delivered on time. Additionally, he always has a holistic approach for
        the problem at hand and is direct in his feedback.
      </span>
    ),
    categories: ['Architecture', 'Deliverables'],
  },
  {
    year: currentYear - 1,
    testimonial:
      "Trevor always thinks about the customer, he uses this super power to enhance user experience of Project B tool. There were many instances where in he came with out of the box ideas like showing automated audits in a different tab, showing RADAR questions section wise and many others. Testimonies about RADAR v2.0's UI actually speaks for his work and efforts.",
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {
          'Trevor always thinks about the customer, he uses this super power to enhance user experience of our '
        }
        <b>Project B</b>
        {
          ' tool. There were many instances where in he came with out of the box ideas like showing automations in a different tab, showing '
        }
        <b>Project C</b> questions section wise and many others. Testimonies
        about <b>Project C</b>'s UI actually speaks for his work and efforts.
      </span>
    ),
    categories: ['Frontend', 'UI/UX'],
  },
  {
    year: currentYear - 1,
    testimonial:
      'Trevor consistently pays great attention to users and customers when building out features and components - solving the root of the problem while improving the user experience.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor consistently pays great attention to users and customers when
        building out features and components - solving the root of the problem
        while improving the user experience.
      </span>
    ),
    categories: ['UI/UX'],
  },
  {
    year: currentYear - 1,
    testimonial:
      'Trevor is also constantly learning about new technologies and how best to implement them for different use cases such as a recent CRON solution we visited that leveraged several AWS technologies.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        Trevor is{' '}
        <i>
          constantly learning about new technologies and how best to implement
          them for different use cases
        </i>
        {', '}
        such as a recent CRON solution we visited that leveraged several AWS
        technologies.
      </span>
    ),
    categories: ['Architecture', 'Mentoring'],
  },
  {
    year: currentYear - 1,
    testimonial:
      'Trevor has a natural inclination to think out of the box to deliver solutions with better ideas, an example being RADAR v2 UI design, which I think he had a major role. Trevor explores new areas/technologies as needed and helps the team, which is a great attribute for a developing leader.',
    relation: RELATIONSHIPS.Amazon,
    isActive: true,
    Component: (
      <span>
        {'Trevor has a '}
        <i>
          natural inclination to think out of the box to deliver solutions with
          better ideas
        </i>
        {', an example being '}
        <b>Project C</b>
        {
          ' UI design, which I think he had a major role. Trevor explores new areas/technologies as needed and helps the team, which is a great attribute for a developing leader.'
        }
      </span>
    ),
    categories: ['Architecture', 'UI/UX'],
  },
  ...NEW_TESTIMONIES,
];

export const FULL_TESTIMONY_LIST = [...TESTIMONIAL_LIST, MANAGER_TESTIMONY];

export const ALL_UNIQUE_CATEGORIES = [
  ...new Set(
    FULL_TESTIMONY_LIST.flatMap((t) => t.categories ?? ['']).filter(
      (c) => c !== '',
    ),
  ),
];
